import { useState, useEffect } from "react";

// Enum to define the connection quality types
enum ConnectionQuality {
  VerySlow = "Very Slow Connection",
  Slow = "Slow Connection",
  Good = "Good Connection",
  Error = "Error in speed test",
  Offline = "Offline",
  Checking = "Checking...",
}

// Interface for the return type of the hook
interface InternetSpeed {
  networkStatus: ConnectionQuality;
  downloadSpeed: string | null;
  isOnline: boolean;
  isOnlineEventTriggered: boolean;
}

const useInternetSpeed = (): InternetSpeed => {
  const [networkStatus, setNetworkStatus] = useState<ConnectionQuality>(
    ConnectionQuality.Checking
  );
  const [downloadSpeed, setDownloadSpeed] = useState<string | null>(null);
  const [isOnline, setIsOnline] = useState<boolean>(true);
  const [isOnlineEventTriggered, setIsOnlineEventTriggered] =
    useState<boolean>(false);

  // Monitor online/offline status
  useEffect(() => {
    const handleOnlineStatus = () => {
      setIsOnlineEventTriggered(true);
      setIsOnline(true);
    };
    const handleOfflineStatus = () => setIsOnline(false);

    window.addEventListener("online", handleOnlineStatus);
    window.addEventListener("offline", handleOfflineStatus);

    return () => {
      window.removeEventListener("online", handleOnlineStatus);
      window.removeEventListener("offline", handleOfflineStatus);
    };
  }, []);

  // Speed test logic
  // const testDownloadSpeed = async () => {
  //   const startTime = Date.now();
  //   const fileUrl =
  //     "https://auction-bazaar-production.imgix.net/09dc3cad-ea46-4422-8d24-00176235c9f0"; // Replace with your file URL

  //   try {
  //     const response = await fetch(fileUrl);
  //     const reader = response.body?.getReader();
  //     if (!reader) {
  //       throw new Error("Unable to read response body");
  //     }

  //     let bytesReceived = 0;

  //     while (true) {
  //       const { done, value } = await reader.read();
  //       if (done) break;
  //       bytesReceived += value.length;
  //     }

  //     const durationInSeconds = (Date.now() - startTime) / 1000;
  //     const speedInMbps =
  //       (bytesReceived * 8) / (durationInSeconds * 1024 * 1024);
  //     setDownloadSpeed(speedInMbps.toFixed(2));

  //     // Determine connection status based on speed
  //     if (speedInMbps < 1) {
  //       setNetworkStatus(ConnectionQuality.VerySlow);
  //     } else if (speedInMbps >= 1 && speedInMbps < 5) {
  //       setNetworkStatus(ConnectionQuality.Slow);
  //     } else {
  //       setNetworkStatus(ConnectionQuality.Good);
  //     }
  //   } catch (error) {
  //     console.error("Error downloading the file:", error);
  //     setNetworkStatus(ConnectionQuality.Error);
  //   }
  // };

  // const testSpeedUsingGoogle = async () => {
  //   const startTime = Date.now();

  //   try {
  //     const response = await fetch("https://www.google.com", {
  //       method: "GET",
  //       cache: "no-cache", // Avoid cached responses
  //     });

  //     const durationInSeconds = (Date.now() - startTime) / 1000;
  //     const fileSizeInBytes = response.headers.get("Content-Length") || 0;
  //     const speedInMbps =
  //       (parseInt(fileSizeInBytes as string) * 8) /
  //       (durationInSeconds * 1024 * 1024);

  //     console.log(`Download Speed: ${speedInMbps.toFixed(2)} Mbps`);

  //     return speedInMbps.toFixed(2); // Return the speed in Mbps
  //   } catch (error) {
  //     console.error("Error testing speed with Google:", error);
  //     return "Error";
  //   }
  // };

  // Perform periodic checks for internet speed
  useEffect(() => {
    if (!isOnline) {
      setNetworkStatus(ConnectionQuality.Offline);
      return;
    }

    // Test speed immediately and then periodically (every 10 seconds)
    // const intervalId = setInterval(() => {
    //   testDownloadSpeed();
    // }, 30000);

    // // Clean up interval on component unmount
    // return () => clearInterval(intervalId);
  }, [isOnline]);

  return { networkStatus, downloadSpeed, isOnline, isOnlineEventTriggered };
};

export default useInternetSpeed;
